<template>
  <div class="section-line-container">
    <ShowAlignmentsButton :line="line" :alignments="alignments" />
    <ShowSirahButton :show-button="line.isSirah" @showSirahClick="onShowSirah" />
    <SectionLine
      :key="line.idx"
      :line="line"
      :alignments="alignments"
      :selected="selected"
      :selected-token="selectedToken"
      :debug="debug"
      @scrollToElement="element => $emit('scrollToElement', element)"
    />
  </div>
</template>

<script>
  import SectionLine from './SectionLine.vue';
  import ShowSirahButton from './ShowSirahButton.vue';
  import ShowAlignmentsButton from './ShowAlignmentsButton.vue';

  import { TOGGLE_SHOW_SIRAH } from '../../constants';

  export default {
    components: { SectionLine, ShowSirahButton, ShowAlignmentsButton },
    props: ['line', 'selectedToken', 'selectedLine', 'alignmentsMap', 'debug'],
    computed: {
      alignments() {
        return Object.keys(this.alignmentsMap)
          .map(key => this.alignmentsMap[key])
          .flat()
          .filter((alignment) => {
            const [start, end] = alignment.leftBoundary;
            return start[0] <= this.line.idx && end[0] >= this.line.idx;
          });
      },
      selected() {
        return Number.isInteger(this.selectedLine) ? this.line.idx === this.selectedLine : false;
      },
    },
    methods: {
      onShowSirah() {
        this.$store.dispatch(TOGGLE_SHOW_SIRAH);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .section-line-container {
    display: flex;
    flex-direction: row;
    .section-text--line {
      flex: 1;
    }
  }
</style>
